module.exports = __webpack_public_path__ + "static/media/background.3dc9daa6.png";